import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { noop } from 'lodash';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useModal } from 'modules/taboola-common-frontend-modules/modals';

export const UNSAVED_CHANGES_MODAL_MESSAGES = {
    title: <FormattedMessage id="app.modal.unsavedChanges.title" tagName="h2" defaultMessage="Leave Page?" />,
    formProps: {
        submitButtonText: (
            <FormattedMessage id="app.modal.unsavedChanges.button.positive" defaultMessage="Yes, leave" />
        ),
        cancelButtonText: <FormattedMessage id="app.modal.unsavedChanges.button.negative" defaultMessage="Stay here" />,
    },
    content: (
        <FormattedMessage
            id="app.modal.unsavedChanges.content"
            defaultMessage="You have unsaved changes that will be lost if you leave this page."
        />
    ),
};

export const useNavigationBlocker = ({ skipBlockNavigationCondition, onBeforeConfirmCancelNavigation = noop }) => {
    const history = useHistory();
    const { open: openModal } = useModal();
    const openConfirmDialog = useCallback(
        async (destinationTo, state, unblock) => {
            const result = await openModal(UNSAVED_CHANGES_MODAL_MESSAGES);

            if (!result) {
                return;
            }

            await onBeforeConfirmCancelNavigation();

            unblock();
            history.push(destinationTo, state);
        },
        [openModal, onBeforeConfirmCancelNavigation, history]
    );

    const blockNavigation = useCallback(() => {
        const customPrompt = destination => {
            const { pathname, search, state } = destination;
            const destinationTo = { pathname, search };

            // This block is needed when we update url inside the same form like is creative
            if (skipBlockNavigationCondition(pathname, search)) {
                return true;
            }

            openConfirmDialog(destinationTo, state, unblock);

            return false;
        };

        const unblock = history.block(customPrompt);

        return unblock;
    }, [history, openConfirmDialog, skipBlockNavigationCondition]);

    return blockNavigation;
};
